import React, { Component } from "react";
import {
  Grid,
  Table,
  Label,
  Popup,
  Icon,
  Button,
  Checkbox
} from "semantic-ui-react";
// import { findindex } from "../../../services/findindex";
import moment from "moment";
import "../accounting.css";
import PaymentModal from "./paymentmodal";
import { Link } from "react-router";
import Roundy from "../../../services/roundy";
import { invformatnumber } from "../../../services/tnminvnumbers";
class InvoiceTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: null,
      invoices: [],
      payInvoice: { workOrderNbr: "" },
      paymentAmount: 0
    };
  }

  gendatarows(custnumber) {
    console.log("table invoices", custnumber);
    let datainvoices = Array.from(this.props.invoices);
    if (this.props.type === "unpaid") {
      datainvoices = this.props.invoices.sort((a, b) => a.number - b.number);
    }
    return datainvoices.map((invoice, index) => {
      if (invoice.custnumber == custnumber) {
        let invwo = this.props.wods.find(
          i => i.workOrderNbr === invoice.workordernumber
        );
        let included =
          this.props.invoices.findIndex(
            inv => inv.workordernumber === invoice.workordernumber
          ) > -1;
        if (this.props.invoices.length && invwo) {
          switch (this.props.type) {
            case "create":
              return (
                <Table.Row negative={invoice.number === 0}>
                  <Table.Cell>
                    <Checkbox
                      checked={invoice.included}
                      onChange={(e, { value }) => {
                        this.props.updatelist(index, !invoice.included);
                      }}
                    />
                  </Table.Cell>
                  <Table.Cell>{invoice.workordernumber}</Table.Cell>
                  <Table.Cell>
                    {invoice.included ? invformatnumber(invoice) : "-"}
                  </Table.Cell>
                  <Table.Cell>{invwo.contactName}</Table.Cell>
                  <Table.Cell textAlign="left">${invoice.amount}</Table.Cell>
                  <Table.Cell>{moment().format("MM/DD/YYYY")}</Table.Cell>
                  <Table.Cell>{invoice.comments}</Table.Cell>
                </Table.Row>
              );
            case "paid":
              let test = 'test';
              return (
                <Table.Row selectable>
                  <Table.Cell>
                    <Link to={"/invlist/" + invoice.id}>
                      {invformatnumber(invoice)}
                    </Link>
                  </Table.Cell>
                  <Table.Cell>{invoice.workordernumber}</Table.Cell>
                  <Table.Cell>{invoice.description}</Table.Cell>
                  <Table.Cell>{invwo.contactName}</Table.Cell>
                  <Table.Cell>
                    ${Roundy(invoice.amount)}
                  </Table.Cell>
                  <Table.Cell>{invoice.paiddate ? moment(invoice.paiddate).format("MM/DD/YYYY") : "N/A"}</Table.Cell>
                  <Table.Cell>{invoice.invcomments}</Table.Cell>
                </Table.Row>
              );

            case "unpaid":
              let daysunpaid = moment().diff(invoice.createdate, "days");
              return (
                <Table.Row selectable>
                  <Table.Cell>
                    <Link to={"/invlist/" + invoice.id}>
                      {invformatnumber(invoice)}
                    </Link>
                  </Table.Cell>
                  <Table.Cell>{invoice.workordernumber}</Table.Cell>
                  <Table.Cell>{invoice.description}</Table.Cell>
                  <Table.Cell>{invwo.contactName}</Table.Cell>
                  <Table.Cell>
                    ${Roundy(invoice.amount - invoice.paidamount)}
                  </Table.Cell>
                  <Table.Cell>{daysunpaid}</Table.Cell>
                  <Table.Cell>{invoice.comments}</Table.Cell>
                  <Table.Cell>
                    <Button.Group>
                      <Popup
                        trigger={
                          <Button
                            color="blue"
                            size="small"
                            icon
                            compact
                            onClick={() =>
                              this.setState({
                                payInvoice: invoice,
                                showModal: true
                              })
                            }
                          >
                            <Icon name="dollar" />
                          </Button>
                        }
                        content="Submit Payment"
                      />
                      <Popup
                        trigger={
                          <Button
                            color="green"
                            size="small"
                            icon
                            compact
                            onClick={() => {
                              this.props.markaspaid({
                                ...invoice,
                                paidamount: invoice.amount,
                                paiddate: moment().format("YYYY-MM-DD")
                              });
                            }}
                          >
                            <Icon name="check" />
                          </Button>
                        }
                        content="Paid in Full"
                      />
                      <Popup
                        trigger={
                          <Button
                            color="red"
                            size="small"
                            icon
                            compact
                            onClick={() => this.props.removeexisting(invoice)}
                          >
                            <Icon name="cancel" />
                          </Button>
                        }
                        content="Delete"
                      />
                    </Button.Group>
                  </Table.Cell>
                </Table.Row>
              );
            case "unsent":
              invoice.submitdate = 1;
              return (
                <Table.Row negative={invoice.number === 0}>
                  <Table.Cell>
                    <Checkbox
                      defaultChecked
                      checked={invoice.submitdate}
                      onChange={(e, { value }) => {
                        let tempinvs = this.state.invoices;
                        let tempindex = tempinvs.findIndex(
                          i => i.id === invoice.id
                        );
                        tempinvs[tempindex].submitdate =
                          1 - tempinvs[tempindex].submitdate;
                        this.setState({ invoices: tempinvs });
                      }}
                    />
                  </Table.Cell>
                  <Table.Cell>{invoice.workordernumber}</Table.Cell>
                  <Table.Cell>{invoice.description}</Table.Cell>
                  <Table.Cell>{invwo.contactName}</Table.Cell>
                  <Table.Cell textAlign="left">${invoice.amount}</Table.Cell>
                  <Table.Cell>{invoice.createdate}</Table.Cell>
                  <Table.Cell>{invoice.comments}</Table.Cell>
                </Table.Row>
              );

              break;
            default:
          }
        }
      }
    });
  }
  genextracells(param) { }

  geninvoices() {
    if (
      this.props.invoices.length > 0 &&
      this.props.customers &&
      this.props.customers.length
    ) {
      // var invoices = this.props.invoices.sort((a, b) => {
      //   let sorter =
      //     parseFloat(a.workordernumber.slice(0, 2)) >=
      //     parseFloat(b.workordernumber.slice(0, 2))
      //       ? 1
      //       : -1;
      //   return sorter;
      // });
      let tempcustomers = this.props.customers.sort(
        (a, b) => a.custnumber - b.custnumber
      );

      return tempcustomers.map(customer => {
        if (
          this.props.invoices.findIndex(
            inv => inv.custnumber === customer.custnumber
          ) > -1
        ) {
          if (this.props.type !== "unpaid" || customer.custnumber !== 9712) {
            let custname = customer.custname;
            return (
              <Table.Body>
                <Table.Row>
                  <Table.Cell colSpan="6">
                    <Label color="red" id="customername" ribbon>
                      <h4>{custname}</h4>
                    </Label>
                  </Table.Cell>
                </Table.Row>
                {this.gendatarows(customer.custnumber)}
              </Table.Body>
            );
          }
        }
      });
    }
  }
  genpaidheader() {
    if (this.props.paid === false) {
      return <Table.HeaderCell>Days Unpaid</Table.HeaderCell>;
    } else {
      return <Table.HeaderCell>Paid Date</Table.HeaderCell>;
    }
  }
  gentableheader() {
    if (this.props.invoices.length > 0) {
      switch (this.props.type) {
        case "create":
          return (
            <Table.Row>
              <Table.HeaderCell>Create</Table.HeaderCell>
              <Table.HeaderCell>WO#</Table.HeaderCell>
              <Table.HeaderCell>INV#</Table.HeaderCell>
              <Table.HeaderCell>Project Manager</Table.HeaderCell>
              <Table.HeaderCell>Inv. Amount</Table.HeaderCell>
              <Table.HeaderCell>Create Date</Table.HeaderCell>
              <Table.HeaderCell>Notes</Table.HeaderCell>
            </Table.Row>
          );
          break;
        case "unpaid":
          return (
            <Table.Row>
              <Table.HeaderCell>Inv#</Table.HeaderCell>
              <Table.HeaderCell>WO#</Table.HeaderCell>
              <Table.HeaderCell>Description</Table.HeaderCell>
              <Table.HeaderCell>Project Manager</Table.HeaderCell>
              <Table.HeaderCell>Amount Outstanding</Table.HeaderCell>
              <Table.HeaderCell>Days Unpaid</Table.HeaderCell>
              <Table.HeaderCell>Create Date</Table.HeaderCell>
              <Table.HeaderCell>Notes</Table.HeaderCell>
            </Table.Row>
          );
          break;
        case "paid":
          return (
            <Table.Row>
              <Table.HeaderCell>Inv#</Table.HeaderCell>
              <Table.HeaderCell>WO#</Table.HeaderCell>
              <Table.HeaderCell>Description</Table.HeaderCell>
              <Table.HeaderCell>Project Manager</Table.HeaderCell>
              <Table.HeaderCell>Amount</Table.HeaderCell>
              <Table.HeaderCell>Paid Date</Table.HeaderCell>
              <Table.HeaderCell>Notes</Table.HeaderCell>
            </Table.Row>
          );
        case "unsent":
          return (
            <Table.Row>
              <Table.HeaderCell>Submit</Table.HeaderCell>
              <Table.HeaderCell>WO#</Table.HeaderCell>
              <Table.HeaderCell>Description</Table.HeaderCell>
              <Table.HeaderCell>Project Manager</Table.HeaderCell>
              <Table.HeaderCell>Inv. Amount</Table.HeaderCell>
              <Table.HeaderCell>Days Unpaid</Table.HeaderCell>
              <Table.HeaderCell>Create Date</Table.HeaderCell>
              <Table.HeaderCell>Notes</Table.HeaderCell>
            </Table.Row>
          );
          break;
      }
    }
  }
  render() {
    let payInvoice = this.state.payInvoice;
    if (!this.props.customers || !this.props.invoices) {
      return <div />;
    } else {
      return (
        <div className="InvoiceTable">
          <Grid>
            <Grid.Row centered>
              <Grid.Column width={10}>
                <Table>
                  <Table.Header>{this.gentableheader()}</Table.Header>
                  {this.geninvoices()}
                </Table>
              </Grid.Column>
            </Grid.Row>
            <PaymentModal
              {...this.props}
              payInvoice={payInvoice}
              updateInvoice={invoice => this.props.markaspaid(invoice)}
              showModal={this.state.showModal}
              handleClose={() => this.setState({ showModal: false })}
            />
          </Grid>
        </div>
      );
    }
  }
}
export default InvoiceTable;



// WEBPACK FOOTER //
// ./src/components/accounting/invoices/invoicetable.js